<app-page name="Piercings" *ngIf="piercings">
	<div class="row">
		<div class="col-4 mb-4" *ngFor="let group of piercings">
			<div class="shadow">
				<div class="card rounded table-responsive border-0">
					<div class="card-header bg-gradient-primary text-light">
						<h3 class="mb-0">{{group.name}}</h3>
					</div>
					<table class="table table-striped table-borderless table-hover table-sm card-body mb-0 rounded-bottom">
						<thead class="p-2">
						<tr>
							<th style="width: 1%"></th>
							<th>
								Name
							</th>
							<th class="text-right">
								Price
							</th>
							<th style="width: 1%"></th>
						</tr>
						</thead>
						<tbody>
						<tr *ngFor="let piercing of group.piercings">
							<td class="text-center">
								<span *ngIf="piercing.available" class="fa fa-check-circle text-success ml-2 mr-2"></span>
								<span *ngIf="!piercing.available" class="fa fa-times-circle text-danger ml-2 mr-2"></span>
							</td>
							<td>{{piercing.name}}</td>
							<td class="text-right">{{piercing.price | currency:"EUR"}}</td>
							<td class="text-right">
								<div class="pl-2 pr-2">
									<button class="btn btn-primary btn-sm" (click)="onEdit(piercing)"><i class="fa fa-wrench"></i></button>
								</div>
							</td>
						</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</app-page>
